import { render, staticRenderFns } from "./CampaignJsonEditor.vue?vue&type=template&id=df2d50a0&"
import script from "./CampaignJsonEditor.vue?vue&type=script&lang=js&"
export * from "./CampaignJsonEditor.vue?vue&type=script&lang=js&"
import style0 from "./CampaignJsonEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports